class Season {
	constructor({
		id = '',
		title = '',
		startDate = '',
		endDate = '',
		activeYn = 0,
		targetUsd = 0,
		targetQuantity = 0,
		totalUsd = 0,
		vatUsd = 0,
		shippingUsd = 0,
		discountedUsd = 0,
		paidUsd = 0,
		soldQuantity = 0,
		updatedBy = '',
		updatedAt = '',
		createdBy = '',
		createdAt = '',
		notStartYn = 0,
		expiredYn = 0,
		productInactiveYn = 0,
		soldOutYn = 0,
		status = 'active',
	} = {}) {
		this.id = id === null ? '' : id
		this.title = title === null ? '' : title
		this.startDate = startDate === null ? '' : startDate
		this.endDate = endDate === null ? '' : endDate
		this.activeYn = activeYn === null ? 0 : activeYn
		this.targetUsd = targetUsd === null ? 0 : targetUsd
		this.targetQuantity = targetQuantity === null ? 0 : targetQuantity
		this.totalUsd = totalUsd === null ? 0 : totalUsd
		this.vatUsd = vatUsd === null ? 0 : vatUsd
		this.shippingUsd = shippingUsd === null ? 0 : shippingUsd
		this.discountedUsd = discountedUsd === null ? 0 : discountedUsd
		this.paidUsd = paidUsd === null ? 0 : paidUsd
		this.soldQuantity = soldQuantity === null ? 0 : soldQuantity
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.createdBy = createdBy === null ? '' : createdBy
		this.createdAt = createdAt === null ? '' : createdAt
		this.notStartYn = notStartYn === null ? 0 : notStartYn
		this.expiredYn = expiredYn === null ? 0 : expiredYn
		this.productInactiveYn = productInactiveYn === null ? 0 : productInactiveYn
		this.soldOutYn = soldOutYn === null ? 0 : soldOutYn
		this.status = status === null ? '' : status
	}
	id: string
	title: string
	startDate: string
	endDate: string
	activeYn: number
	targetUsd: number
	targetQuantity: number
	totalUsd: number
	vatUsd: number
	shippingUsd: number
	discountedUsd: number
	paidUsd: number
	soldQuantity: number
	updatedBy: string
	updatedAt: string
	createdBy: string
	createdAt: string
	notStartYn: number
	expiredYn: number
	productInactiveYn: number
	soldOutYn: number
	status: string
}

export { Season }
